import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRole from "../../authorization/hooks/useHasRole";

import HomeSuperAdminView from "../views/HomeSuperAdminView";

export default function HomeSuperAdmin() {
	const hasRole = useHasRole();

	if (!hasRole("owner", "admin")) {
		return <Unauthorized />;
	}

	return <HomeSuperAdminView />;
}
